import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import translationEN from "../../constants/locales/en/translation.json";
import translationID from "../../constants/locales/id/translation.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('lang') || 'en',
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export const ProductDemoFooter = () => {
    const { t } = useTranslation();

    return (
      <div className="footer" style={{ backgroundColor: '#2d3494', color: '#ffffff', fontFamily: 'Lato, sans-serif', position: 'fixed', bottom: 0, width: '100%', height: 'auto', lineHeight: '1.5', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px', zIndex: 10 }}>
        <div style={{ flex: 2 }}>
          <p style={{ margin: 0, fontSize: '18px', lineHeight: '1.5' }} data-testid="product-demo-footer">
          {t("product_demo_footer")}
          </p>
        </div>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <a href="/login" style={{ textDecoration: 'none', backgroundColor: '#ffffff', color: '#2d3494', padding: '12px 24px', borderRadius: '4px', border: '1px solid #ffffff', fontSize: '16px' }} data-testid="product-demo-login">{t("product_demo_login")}</a>
          <span style={{ color: '#ffffff', margin: '0 10px', fontSize: '16px' }} data-testid="product-demo-or">{t("product_demo_or")}</span>
          <a href="/register" style={{ textDecoration: 'none', backgroundColor: '#ffffff', color: '#2d3494', padding: '12px 24px', borderRadius: '4px', fontSize: '16px' }} data-testid="product-demo-signup">{t("product_demo_signup")}</a>
        </div>
      </div>
    );
  };
  